@if (givenName) {
  <h2 class="uk-h2 uk-text-center">Bonjour, {{ givenName }} {{ familyName }}!</h2>
}

@if (tokenService.hasRole('MANAGER')) {
  <div class="uk-grid-small" uk-grid>
    <div class="uk-width-1-1 uk-width-1-2@s">
      <mat-card>
        <mat-card-content>
          <div class="information-tile-header">Chiffre d'affaire des tickets aujourd'hui
          </div>
          <div style="font-weight: 700; font-size: 1.875rem; line-height: 2.25rem">
            @if (resume()) {
              {{ resume().ticketRevenue.today | numberFormat }} FCFA
            } @else {
              <mat-spinner></mat-spinner>
            }
          </div>
        </mat-card-content>
      </mat-card>
    </div>
    <div class="uk-width-1-1 uk-width-1-2@s">
      <mat-card>
        <mat-card-content>
          <div class="information-tile-header">
            Nombre de tickets vendus aujourd'hui
          </div>
          <div style="font-weight: 700; font-size: 1.875rem; line-height: 2.25rem">
            @if (resume()) {
              {{ resume().ticketNumber.today | numberFormat }}
            } @else {
              <mat-spinner></mat-spinner>
            }
          </div>
        </mat-card-content>
      </mat-card>
    </div>
    @if (!hideParcels) {
      <div class="uk-width-1-1 uk-width-1-2@s">
        <mat-card class="information-tile">
          <mat-card-content>
            <div class="information-tile-header">
              Chiffre d'affaire des colis aujourd'hui
            </div>
            <div style="font-weight: 700; font-size: 1.875rem; line-height: 2.25rem">
              @if (resume()) {
                {{ resume().parcelRevenue.today | numberFormat }} FCFA
              } @else {
                <mat-spinner></mat-spinner>
              }
            </div>
          </mat-card-content>
        </mat-card>
      </div>
      <div class="uk-width-1-1 uk-width-1-2@s">
        <mat-card class="information-tile">
          <mat-card-content>
            <div class="information-tile-header">
              Nombre de colis vendus aujourd'hui
            </div>
            <div style="font-weight: 700; font-size: 1.875rem; line-height: 2.25rem">
              @if (resume()) {
                {{ resume().parcelNumber.today | numberFormat }}
              } @else {
                <mat-spinner></mat-spinner>
              }
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    }
    <div class="uk-width-1-1">
      <mat-card style="margin-top: 10px">
        <mat-card-header>
          <mat-card-title>Chiffre d'affaire</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <antm-grouped-vertical-bar-chart [data]="groupedData"
                                           style="width: 100%; height: 400px;"></antm-grouped-vertical-bar-chart>
        </mat-card-content>
      </mat-card>
    </div>
    <div class="uk-width-1-1">
      <mat-card class="information-tile">
        <mat-card-header>
          <mat-card-title>Répartition des revenus des tickets</mat-card-title>
        </mat-card-header>

        <mat-card-content>
          <div class="uk-grid">

            <div class="uk-width-1-2">
              <div style="font-weight: 500; font-size: 0.875rem; line-height: 1.25rem;">
                Cette semaine
              </div>
              <div style="font-weight: 700; font-size: 1.875rem; line-height: 2.25rem">
                @if (resume()) {
                  {{ resume().ticketRevenue.week | numberFormat }} FCFA
                } @else {
                  <mat-spinner diameter="48"/>
                }
              </div>
            </div>
            <div class="uk-width-1-2">
              <div style="font-weight: 500; font-size: 0.875rem; line-height: 1.25rem;">
                Ce mois
              </div>
              <div style="font-weight: 700; font-size: 1.875rem; line-height: 2.25rem">
                @if (resume()) {
                  {{ resume().ticketRevenue.month | numberFormat }} FCFA
                } @else {
                  <mat-spinner></mat-spinner>
                }
                <i class="material-icons">payments</i>
              </div>
            </div>
            <div class="uk-width-1-2">
              <div style="font-weight: 500; font-size: 0.875rem; line-height: 1.25rem;">
                Cette année
              </div>
              <div style="font-weight: 700; font-size: 1.875rem; line-height: 2.25rem">
                @if (resume()) {
                  {{ resume().ticketRevenue.year | numberFormat }} FCFA
                } @else {
                  <mat-spinner></mat-spinner>
                }
                <i class="material-icons">payments</i>
              </div>
            </div>
            <div class="uk-width-1-2">
              <div style="font-weight: 500; font-size: 0.875rem; line-height: 1.25rem;">
                Depuis le début
              </div>
              <div style="font-weight: 700; font-size: 1.875rem; line-height: 2.25rem">
                @if (resume()) {
                  {{ resume().ticketRevenue.allTime | numberFormat }} FCFA
                } @else {
                  <mat-spinner></mat-spinner>
                }
                <i class="material-icons">payments</i>
              </div>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
    @if (!hideParcels) {
      <div class="uk-width-1-1">
        <mat-card class="information-tile">
          <mat-card-header>
            <mat-card-title>Répartition des revenus des colis</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div class="uk-grid">
              <div class="uk-width-1-2">
                <div style="font-weight: 500; font-size: 0.875rem; line-height: 1.25rem;">
                  Cette semaine
                </div>
                <div style="font-weight: 700; font-size: 1.875rem; line-height: 2.25rem">
                  @if (resume()) {
                    {{ resume().parcelRevenue.week | numberFormat }} FCFA
                  } @else {
                    <mat-spinner></mat-spinner>
                  }
                </div>
              </div>
              <div class="uk-width-1-2">
                <div style="background-color: #f5f5f5;">
                  <div style="font-weight: 500; font-size: 0.875rem; line-height: 1.25rem;">
                    Ce mois
                  </div>
                  <div style="font-weight: 700; font-size: 1.875rem; line-height: 2.25rem">
                    @if (resume()) {
                      {{ resume().parcelRevenue.month | numberFormat }} FCFA
                    } @else {
                      <mat-spinner></mat-spinner>
                    }
                    <i class="material-icons">payments</i>
                  </div>
                </div>
              </div>
              <div class="uk-width-1-2">
                <div style="font-weight: 500; font-size: 0.875rem; line-height: 1.25rem;">
                  Cette année
                </div>
                <div style="font-weight: 700; font-size: 1.875rem; line-height: 2.25rem">
                  @if (resume()) {
                    {{ resume().parcelRevenue.year | numberFormat }} FCFA
                  } @else {
                    <mat-spinner></mat-spinner>
                  }
                  <i class="material-icons">payments</i>
                </div>
              </div>
              <div class="uk-width-1-2">
                <div style="font-weight: 500; font-size: 0.875rem; line-height: 1.25rem;">
                  Depuis le début
                </div>
                <div style="font-weight: 700; font-size: 1.875rem; line-height: 2.25rem">
                  @if (resume()) {
                    {{ resume().parcelRevenue.allTime | numberFormat }} FCFA
                  } @else {
                    <svg class="spinner" width="48" height="48" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="24" cy="24" r="20" fill="none" stroke="#e0e0e0" stroke-width="4"/>
                      <path d="M24,4 A20,20 0 0,1 44,24" fill="none" stroke="#1976d2" stroke-width="4"
                            stroke-linecap="round"/>
                    </svg>
                  }
                  <i class="material-icons">payments</i>
                </div>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    }
    <div class="uk-width-1-1">
      <mat-card class="information-tile">
        <mat-card-header>
          <mat-card-title>Répartition du nombre de tickets</mat-card-title>
        </mat-card-header>

        <mat-card-content>
          <div class="uk-grid">

            <div class="uk-width-1-2">
              <div style="font-weight: 500; font-size: 0.875rem; line-height: 1.25rem;">
                Cette semaine
              </div>
              <div style="font-weight: 700; font-size: 1.875rem; line-height: 2.25rem">
                @if (resume()) {
                  {{ resume().ticketNumber.week | numberFormat }}
                } @else {
                  <mat-spinner></mat-spinner>
                }
              </div>
            </div>
            <div class="uk-width-1-2">
              <div style="font-weight: 500; font-size: 0.875rem; line-height: 1.25rem;">
                Ce mois
              </div>
              <div style="font-weight: 700; font-size: 1.875rem; line-height: 2.25rem">
                @if (resume()) {
                  {{ resume().ticketNumber.month | numberFormat }}
                } @else {
                  <mat-spinner></mat-spinner>
                }

              </div>
            </div>
            <div class="uk-width-1-2">
              <div style="font-weight: 500; font-size: 0.875rem; line-height: 1.25rem;">
                Cette année
              </div>
              <div style="font-weight: 700; font-size: 1.875rem; line-height: 2.25rem">
                @if (resume()) {
                  {{ resume().ticketNumber.year | numberFormat }}
                } @else {
                  <mat-spinner></mat-spinner>
                }

              </div>
            </div>
            <div class="uk-width-1-2">
              <div style="font-weight: 500; font-size: 0.875rem; line-height: 1.25rem;">
                Depuis le début
              </div>
              <div style="font-weight: 700; font-size: 1.875rem; line-height: 2.25rem">
                @if (resume()) {
                  {{ resume().ticketNumber.allTime | numberFormat }}
                } @else {
                  <mat-spinner></mat-spinner>
                }

              </div>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
    @if (!hideParcels) {
      <div class="uk-width-1-1">
        <mat-card class="information-tile">
          <mat-card-header>
            <mat-card-title>Répartition du nombre de colis</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div class="uk-grid">
              <div class="uk-width-1-2">
                <div style="font-weight: 500; font-size: 0.875rem; line-height: 1.25rem;">
                  Cette semaine
                </div>
                <div style="font-weight: 700; font-size: 1.875rem; line-height: 2.25rem">
                  @if (resume()) {
                    {{ resume().parcelNumber.week | numberFormat }}
                  } @else {
                    <mat-spinner></mat-spinner>
                  }
                </div>
              </div>
              <div class="uk-width-1-2">
                <div style="background-color: #f5f5f5;">
                  <div style="font-weight: 500; font-size: 0.875rem; line-height: 1.25rem;">
                    Ce mois
                  </div>
                  <div style="font-weight: 700; font-size: 1.875rem; line-height: 2.25rem">
                    @if (resume()) {
                      {{ resume().parcelNumber.month | numberFormat }}
                    } @else {
                      <mat-spinner></mat-spinner>
                    }

                  </div>
                </div>
              </div>
              <div class="uk-width-1-2">
                <div style="font-weight: 500; font-size: 0.875rem; line-height: 1.25rem;">
                  Cette année
                </div>
                <div style="font-weight: 700; font-size: 1.875rem; line-height: 2.25rem">
                  @if (resume()) {
                    {{ resume().parcelNumber.year | numberFormat }}
                  } @else {
                    <mat-spinner></mat-spinner>
                  }

                </div>
              </div>
              <div class="uk-width-1-2">
                <div style="font-weight: 500; font-size: 0.875rem; line-height: 1.25rem;">
                  Depuis le début
                </div>
                <div style="font-weight: 700; font-size: 1.875rem; line-height: 2.25rem">
                  @if (resume()) {
                    {{ resume().parcelNumber.allTime | numberFormat }}
                  } @else {
                    <mat-spinner></mat-spinner>
                  }

                </div>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    }
  </div>

}
